import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}
export function Input({
  label,
  error,
  className = '',
  id,
  ...props
}: InputProps) {
  const inputId = id || props.name;
  return <div className="w-full" data-id="element-180">
      {label && <label htmlFor={inputId} className="block text-sm font-medium text-slate-300 mb-1.5" data-id="element-181">
          {label}
        </label>}
      <input id={inputId} className={`
          block w-full rounded-md bg-navy-800 border border-slate-700 
          text-white placeholder-slate-500
          focus:border-teal-500 focus:ring-1 focus:ring-teal-500 focus:outline-none
          disabled:opacity-50 disabled:bg-navy-900
          px-3 py-2 text-sm transition-colors
          ${error ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : ''}
          ${className}
        `} {...props} data-id="element-182" />
      {error && <p className="mt-1 text-sm text-red-400" data-id="element-183">{error}</p>}
    </div>;
}
interface TextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
}
export function TextArea({
  label,
  error,
  className = '',
  id,
  ...props
}: TextAreaProps) {
  const inputId = id || props.name;
  return <div className="w-full" data-id="element-184">
      {label && <label htmlFor={inputId} className="block text-sm font-medium text-slate-300 mb-1.5" data-id="element-185">
          {label}
        </label>}
      <textarea id={inputId} className={`
          block w-full rounded-md bg-navy-800 border border-slate-700 
          text-white placeholder-slate-500
          focus:border-teal-500 focus:ring-1 focus:ring-teal-500 focus:outline-none
          disabled:opacity-50 disabled:bg-navy-900
          px-3 py-2 text-sm transition-colors
          ${error ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : ''}
          ${className}
        `} {...props} data-id="element-186" />
      {error && <p className="mt-1 text-sm text-red-400" data-id="element-187">{error}</p>}
    </div>;
}